import { render } from "./PageInfo.vue?vue&type=template&id=92ab8772&scoped=true&lang=pug"
import script from "./PageInfo.vue?vue&type=script&lang=js"
export * from "./PageInfo.vue?vue&type=script&lang=js"

import "./PageInfo.vue?vue&type=style&index=0&id=92ab8772&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92ab8772"],['__file',"src/common/pagination/PageInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "92ab8772"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('92ab8772', __exports__)) {
    api.reload('92ab8772', __exports__)
  }
  
  module.hot.accept("./PageInfo.vue?vue&type=template&id=92ab8772&scoped=true&lang=pug", () => {
    api.rerender('92ab8772', render)
  })

}


export default __exports__